export const CLASS_NAMES = {
  title:
    'text-style-f-em text-neutral-800 md:text-style-e md:text-neutral-900 break-all',
};

export const DESCRIPTION = 'Title';
